"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptForm = exports.mapCustomFormToAcceptanceData = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles = __importStar(require("./AcceptForm.css"));
var lodash_1 = require("lodash");
var CleanJson_1 = __importDefault(require("@CommonFrontend/CleanJson/CleanJson"));
var AcceptFormContextProvider_1 = require("./AcceptFormContextProvider");
var classnames_1 = __importDefault(require("classnames"));
var mapCustomFormToAcceptanceData = function (fields, incomingData) {
    var customForm = fields.map(function (field) {
        var _a, _b;
        return {
            field: field.name,
            value: (_b = (_a = incomingData[field.id]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
        };
    });
    return (0, CleanJson_1.default)(customForm);
};
exports.mapCustomFormToAcceptanceData = mapCustomFormToAcceptanceData;
var AcceptForm = function (_a) {
    var customForm = _a.customForm, printMode = _a.printMode, visualMode = _a.visualMode;
    var customFormFields = customForm ? customForm.fields : [];
    var formApiRef = (0, react_1.useRef)();
    var formRef = (0, react_1.useRef)(null);
    var formValuesRef = (0, react_1.useRef)();
    var hasValidationError = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        customForm === null || customForm === void 0 ? void 0 : customForm.registerImperativeHandlers({
            validate: function () {
                var _a;
                (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
                var isValid = !hasValidationError.current;
                return isValid;
            },
            finalise: function (data) {
                if (formValuesRef === null || formValuesRef === void 0 ? void 0 : formValuesRef.current) {
                    var customFormData = (0, exports.mapCustomFormToAcceptanceData)(customFormFields, formValuesRef.current);
                    data.customForm = customFormData;
                    data.usedCustomForm = true;
                }
                return data;
            },
            devFill: function () {
                customForm.fields.forEach(function (field) {
                    var _a, _b;
                    if ((formValuesRef === null || formValuesRef === void 0 ? void 0 : formValuesRef.current) && !formValuesRef.current[field.id]) {
                        if (field.type === "dropdown") {
                            (_a = formApiRef.current) === null || _a === void 0 ? void 0 : _a.change(field.id, (0, lodash_1.sample)(field.items));
                        }
                        else {
                            (_b = formApiRef.current) === null || _b === void 0 ? void 0 : _b.change(field.id, (0, utils_1.randomString)(10));
                        }
                    }
                });
            },
            previewAutoFill: function () {
                customForm.fields.forEach(function (field) {
                    var _a, _b;
                    if ((formValuesRef === null || formValuesRef === void 0 ? void 0 : formValuesRef.current) && !formValuesRef.current[field.id]) {
                        if (field.type === "dropdown") {
                            (_a = formApiRef.current) === null || _a === void 0 ? void 0 : _a.change(field.id, (0, lodash_1.sample)(field.items));
                        }
                        else {
                            (_b = formApiRef.current) === null || _b === void 0 ? void 0 : _b.change(field.id, (0, utils_1.randomString)(10));
                        }
                    }
                });
            },
        });
    }, []);
    return (react_1.default.createElement(AcceptFormContextProvider_1.AcceptFormContextProvider, { isPrintMode: printMode, visualMode: visualMode },
        react_1.default.createElement(AcceptFormContextProvider_1.AcceptFormContextConsumer, null, function (_a) {
            var visualMode = _a.visualMode, isPrintMode = _a.isPrintMode;
            return (react_1.default.createElement(kaleidoscope_1.FormComponent, { ref: formRef, fieldSize: isPrintMode ? "small" : "large", shakeOnError: false, onSubmit: function (args) {
                    return Promise.resolve();
                }, className: (0, classnames_1.default)(["accept-form", styles.acceptForm({ visualMode: visualMode, isPrintMode: isPrintMode })]) },
                react_1.default.createElement(kaleidoscope_1.FormContext.Consumer, null, function (ctx) {
                    formApiRef.current = ctx ? ctx.form : undefined;
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        customFormFields.map(function (field) {
                            if (field.type === "dropdown") {
                                return react_1.default.createElement(FormSelectComponent, { key: field.id, field: field });
                            }
                            return (react_1.default.createElement(kaleidoscope_1.FormTextInput, { name: field.id, label: field.isRequired && visualMode === "simple" ? "".concat(field.name, " *") : field.name, key: field.id, validate: function (value) {
                                    if (field.isRequired && !value) {
                                        return "This field cannot be empty";
                                    }
                                } }));
                        }),
                        react_1.default.createElement(react_final_form_1.FormSpy, { subscription: { values: true }, onChange: function (form) {
                                formValuesRef.current = form.values;
                            } }),
                        react_1.default.createElement(react_final_form_1.FormSpy, { subscription: { hasValidationErrors: true }, onChange: function (form) {
                                hasValidationError.current = form.hasValidationErrors;
                            } })));
                })));
        })));
};
exports.AcceptForm = AcceptForm;
var FormSelectComponent = function (_a) {
    var field = _a.field;
    var _b = (0, AcceptFormContextProvider_1.useAcceptFormContext)(), isPrintMode = _b.isPrintMode, visualMode = _b.visualMode;
    if (isPrintMode) {
        return (react_1.default.createElement("div", { className: styles.acceptFormSelectField },
            react_1.default.createElement(kaleidoscope_1.Label, { long: true, size: "s", element: "label" }, field.isRequired && visualMode === "simple" ? "".concat(field.name, " *") : field.name),
            react_1.default.createElement("div", null, field.items.map(function (item) { return (react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { label: item, id: item, value: item }, isSelected: false, onChange: lodash_1.noop, size: kaleidoscope_1.CheckboxSize.Small, key: item })); }))));
    }
    return (react_1.default.createElement(kaleidoscope_1.FormSelect, { className: styles.acceptFormSelectField, "data-is-required": field.isRequired, name: field.id, label: field.isRequired && visualMode === "simple" ? "".concat(field.name, " *") : field.name, key: field.id, initialValue: "", validate: function (value) {
            if (field.isRequired && !value) {
                return "Please select an option";
            }
        } }, field.items.map(function (item) {
        return (react_1.default.createElement(kaleidoscope_1.SelectOption, { value: item, key: item }, item));
    })));
};
